<template>
    <HeroBannerForm :monevo-logo="themeSetting('hero_form_monevo_logo')" />
</template>

<script>
import { useStore } from 'vuex'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
}
</script>
